import { Center } from '@tempots/beatui'
import { attr, Empty, Ensure, html, Value, When } from '@tempots/dom'
import { BigLoader } from './big-loader'

export interface ProgressPanelData {
  title: string
  description?: string
  showLoader?: boolean
}

export interface ProgressPanelOptions {
  value: Value<ProgressPanelData>
}

export function ProgressPanel({ value }: ProgressPanelOptions) {
  const signal = Value.toSignal(value)
  const showLoader = signal.map(s => s.showLoader ?? true)
  return html.div(
    attr.class('w-full h-full bg-gray-100 p-4'),
    Center(
      {},
      html.div(
        attr.class('flex flex-col gap-2'),
        When(
          showLoader,
          () => BigLoader(),
          () => Empty
        ),
        html.div(
          attr.class('font-semibold text-sm text-gray-600'),
          signal.$.title
        ),
        Ensure(signal.$.description, description =>
          html.div(
            attr.class('text-sm leading-tight text-gray-500'),
            description
          )
        )
      )
    )
  )
}
